module.exports = __webpack_public_path__ + "img/20.66f468be.jpg";